// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_13-map-fullscreen-control {
  /* Size */
  --perxis-auto-map-fullscreen-control-button-size-inner: var(--perxis-auto-map-fullscreen-control-button-size, 50px);
  /* End Size */
  /* Color */
  --perxis-auto-map-fullscreen-control-button-divider-color-inner: var(
    --perxis-auto-map-fullscreen-control-button-divider-color,
    var(--perxis-auto-root-ninth-color-inner)
  );
  --perxis-auto-map-fullscreen-control-background-color-inner: var(
    --perxis-auto-map-fullscreen-control-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-map-fullscreen-control-button-hover-background-color-inner: var(
    --perxis-auto-map-fullscreen-control-button-hover-background-color,
    var(--perxis-auto-root-seventh-color-inner)
  );
  --perxis-auto-map-fullscreen-control-button-hover-icon-color-inner: var(
    --perxis-auto-map-fullscreen-control-button-hover-icon-color,
    var(--perxis-auto-root-fourth-color-inner)
  );
  --perxis-auto-map-fullscreen-control-button-icon-color-inner: var(
    --perxis-auto-map-fullscreen-control-button-icon-color,
    var(--perxis-auto-root-second-color-inner)
  );
  /* End Color */
  /* Border */
  --perxis-auto-map-fullscreen-control-button-border-inner: var(--perxis-auto-map-fullscreen-control-button-border, 0);
  --perxis-auto-map-fullscreen-control-border-radius-inner: var(--perxis-auto-map-fullscreen-control-border-radius, 8px);
  /* End Border */
  /* Box Shadow */
  --perxis-auto-map-fullscreen-control-box-shadow-inner: var(
    --perxis-auto-map-fullscreen-control-box-shadow,
    0px 0px 20px 0px #2626261a
  );
  /* End Box Shadow */
  position: absolute;
  z-index: 1;
  right: 18px;
  display: inline-flex;
  flex-direction: column;
  background-color: var(--perxis-auto-map-fullscreen-control-background-color-inner);
  border-radius: var(--perxis-auto-map-fullscreen-control-border-radius-inner);
  box-shadow: var(--perxis-auto-map-fullscreen-control-box-shadow-inner);
}
.perxis-auto-1_16_13-map-fullscreen-control-button.ant-5_17_0-btn.perxis-auto-1_16_13-button.perxis-auto-1_16_13-button-ghost {
  --perxis-auto-button-ghost-hover-background-color-inner: var(
    --perxis-auto-map-fullscreen-control-button-hover-background-color-inner
  );
  --perxis-auto-button-ghost-hover-icon-color-inner: var(
    --perxis-auto-map-fullscreen-control-button-hover-icon-color-inner
  );
  --perxis-auto-button-icon-only-border-radius-inner: var(--perxis-auto-map-fullscreen-control-border-radius-inner);
  --perxis-auto-button-ghost-icon-color-inner: var(--perxis-auto-map-fullscreen-control-button-icon-color-inner);
  height: var(--perxis-auto-map-fullscreen-control-button-size-inner);
  width: var(--perxis-auto-map-fullscreen-control-button-size-inner);
  border-width: var(--perxis-auto-map-fullscreen-control-button-border-inner) !important;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
